// modules
import { makeVar } from './makeVar'

export const [search, clearSearch] = makeVar([], {
  storage: localStorage,
  storageKey: 'admin-search-input',
})
